/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * CopyToClipboard
 *
 */
import React, { memo, useState, useRef, useEffect } from 'react';
import { Conditional, Popup, Text } from '@cashfree-intl/coherent';
import CustomIcon from 'components/CustomIcons';
import { copyToClipboard } from 'utils/common';
import { COPY_TO_CLIPBOARD, GREEN_TICK } from 'utils/constants';
import { StyledIconSpan } from './styled';

function CopyToClipboard({
  selectedText = '',
  successPopupText = 'Copied!',
  popupPosition = 'top center',
}: {
  selectedText: string;
  successPopupText?: string;
  popupPosition?: string;
}) {
  const [icon, setIcon] = useState(COPY_TO_CLIPBOARD);

  const popupRef = useRef(null);

  const handleCopyToClipboardClick = () => {
    copyToClipboard(selectedText, false)();

    if (icon !== COPY_TO_CLIPBOARD) return;

    setIcon(GREEN_TICK);

    setTimeout(() => {
      setIcon(COPY_TO_CLIPBOARD);
    }, 3000);
  };

  // added this because popup content was not visible after icon changed to successTick(required us to move cursor away and then again hover on success icon)
  const simulateMouseOver = () => {
    // Check if the ref is available
    if (popupRef.current) {
      // Create a new mouseover event
      const event = new MouseEvent('mouseover', {
        bubbles: true,
        cancelable: true,
      });

      // Dispatch the event on the target element
      popupRef.current.dispatchEvent(event);
    }
  };

  useEffect(() => {
    if (icon === GREEN_TICK) {
      simulateMouseOver();
    }
  }, [icon]);

  return (
    <>
      <Conditional if={icon === GREEN_TICK}>
        <Popup
          trigger={
            <StyledIconSpan
              className="pointer copied-success-icon"
              ref={popupRef}
            >
              <CustomIcon componentName={GREEN_TICK} />
            </StyledIconSpan>
          }
          content={<Text variant="p14">{successPopupText}</Text>}
          position={popupPosition}
        />
      </Conditional>
      <Conditional if={icon === COPY_TO_CLIPBOARD}>
        <StyledIconSpan
          onClick={handleCopyToClipboardClick}
          className="pointer copy-to-clipboard-button"
        >
          <CustomIcon componentName={COPY_TO_CLIPBOARD} />
        </StyledIconSpan>
      </Conditional>
    </>
  );
}

export default memo(CopyToClipboard);
